/* eslint-disable no-undef */
import { isOusSite } from 'src/utils/util';

/**
 * Derives the auth configuration from the effective BASE_URL.
 *
 * On-prem URLs contain 'wcms' → US-style auth (query params, Bearer, tokenField: 'value')
 * CCV2 URLs don't contain 'wcms' → OUS-style auth (URLSearchParams body, Basic auth, tokenField: 'access_token')
 *
 * This handles all deployment modes automatically:
 *   - All on-prem:  BASE_URL=*wcms*, BASE_URL_OUS=*wcms*  → both onprem auth
 *   - All CCV2:     BASE_URL=api.*.commerce.*, BASE_URL_OUS=api.*.commerce.*  → both ccv2 auth
 *   - Hybrid:       BASE_URL=*wcms*, BASE_URL_OUS=api.*.commerce.*  → US=onprem, OUS=ccv2
 */
export const getAuthConfig = () => {
    const baseUrl = isOusSite()
        ? (process.env.BASE_URL_OUS || process.env.BASE_URL)
        : process.env.BASE_URL;

    const isOnPrem = baseUrl?.includes('wcms');

    if (isOnPrem) {
        return {
            tokenUrl: 'mycaseauthserver/oauth/token',
            tokenField: 'value',
            useBasicAuth: false,
        };
    }

    return {
        tokenUrl: 'authorizationserver/oauth/token',
        tokenField: 'access_token',
        useBasicAuth: true,
    };
};
